module.exports = __webpack_public_path__ + "img/icon-shield.2af058a8.svg";